// src/routes/RequireAdmin.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../store/auth';

export default function RequireAdmin() {
  const booted = useAuth(s => s.booted);
  const user   = useAuth(s => s.user);
  const token  = useAuth(s => s.token);
  const loc = useLocation();

  // 1) Пока не знаем состояние (идёт boot + возможный авто-рефреш access-токена) — ничего не решаем
  if (!booted) return null; // можно вывести скелетон/прелоадер, если хочешь

  // 2) Разрешаем только настоящего админа
  const isAdmin = !!token && user && user.role === 'admin';
  if (!isAdmin) {
    return <Navigate to="/admin/login" state={{ from: loc }} replace />;
  }

  return <Outlet />;
}
